import { joinProcessBusinessTypeConstants } from './businessType.constant';
import { joinProcessCropTypeConstants } from './cropType.constant';
import { joinProcessReasonConstants } from './reason.constant';
import { joinProcessTractorOwnCheckConstants } from './tractorOwnCheck.constant';
import { joinProcessTractorWantBuyCheckConstants } from './tractorWantBuyCheck.constant';

export const joinProcessConstants = {
  businessType: joinProcessBusinessTypeConstants,
  cropType: joinProcessCropTypeConstants,
  reason: joinProcessReasonConstants,
  tractorOwnCheck: joinProcessTractorOwnCheckConstants,
  tractorWantBuyCheck: joinProcessTractorWantBuyCheckConstants,
};
